import { z, isoZ } from 'my-zod'
import { enumOptionsToObject, SuperProductLineEnum } from '../../internal'

export const forecastSourceOptions = ['Polaris', 'Outfitter', 'PrevSystem', 'IgnoreForecast'] as const
export const forecastSources = enumOptionsToObject(forecastSourceOptions)
export type ForecastSource = (typeof forecastSourceOptions)[number]
export const forecastSourceLabels: Record<ForecastSource, string> = {
  Polaris: 'Polaris',
  Outfitter: 'Outfitter',
  PrevSystem: 'Prev System',
  IgnoreForecast: 'Ignore Forecast'
}
export const ForecastSourceEnum = z.enum(forecastSourceOptions).setEnumLabels(forecastSourceLabels)

export const outfitterForecastModel = z.object({
  id: z.number().int(),
  outfitterId: z.number().int(),
  yearMonth: isoZ.yearMonth(),
  forecastSource: ForecastSourceEnum,
  superProductLine: SuperProductLineEnum,
  rentalForecastAmount: z.number().int().nonnegative(),
  createdDate: isoZ.instant(),
  lastModifiedDate: isoZ.instant()
})

export type outfitterForecastModel = z.infer<typeof outfitterForecastModel>
